/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_7fcf1775"]'><cube-button open-type="contact" :show-message-card="(true)" send-message-img="https://dpubstatic.udache.com/static/dpubimg/e7207fae-28de-4b5f-b082-329ff0b01ce0.png" send-message-title="点击返回mpx-cube-ui组件库" send-message-path="/pages/button/index" tip="需在微信小程序环境预览">客服会话</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_7fcf1775"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_7fcf1775"}
  /** script content **/
  require("./btn-contact.mpx.js?isComponent&outputPath=components%2Fbtn-contact7fcf1775%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-contact.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-contact7fcf1775%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_7fcf1775"],
    ctorType: "component",
    outputPath: "components/btn-contact7fcf1775/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>